<template>
  <window-layout width="640px">
    <h1>{{ strings.title }}</h1>
    <p>{{ strings.text }}</p>
    <v-button
      theme="primary"
      view="transparent"
      class="button__link"
      @click="goFallback()"
    >{{ strings.button }}</v-button>
  </window-layout>
</template>

<script>
import WindowLayout from '@/layouts/Window.vue'

export default {
  name: 'NotFound',
  components: {
    WindowLayout
  },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data: () => ({
    fallback: null,
    strings: null
  }),
  methods: {
    goFallback() {
      this.$router.push(this.fallback || { name: 'home' })
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.fallback = from
    })
  },
  created() {
    const map = {
      404: {
        title: this.$t('v.error.404title'),
        text: this.$t('v.error.404text'),
        button: this.$t('v.error.404buttonBack')
      },
      500: {
        title: this.$t('v.error.500title'),
        text: this.$t('v.error.500text'),
        button: this.$t('v.error.500buttonBack')
      }
    }

    this.strings = map[this.type]
  }
}
</script>

<style scoped>
.button__link {
  align-self: flex-start;
  padding: 0;
}
</style>
